import { LEADERS_SECTION_DETAILS } from "../../lib/lib";
import { CiLink } from "react-icons/ci";

function Leadership() {
    let cards=[]
    let cards2 = []
    let cards1 = []
    LEADERS_SECTION_DETAILS.slice(0,1).forEach(element => {
      cards1.push(<CMCard name={element.name} title={element.title} image = {element.image} detail={element.details} link = {element.site} />)
  });
    LEADERS_SECTION_DETAILS.slice(1,5).forEach(element => {
        cards.push(<Card name={element.name} title={element.title} image = {element.image} detail={element.details} link = {element.site} />)
    });
    LEADERS_SECTION_DETAILS.slice(5,7).forEach(element => {
      cards2.push(<Card name={element.name} title={element.title} image = {element.image} detail={element.details} link = {element.site}/>)
  });
    return (
        <div id='leadership' className="leadership ">
            <h1 className="heading">Leadership</h1>
            <div className="flex w-full flex-col gap-7 items-center justify-center">
            <div className="grid  gap-y-4 gap-x-2 max-sm:grid-cols-1 w-full  place-items-center  max-w-[80%]"  >
                {cards1}
                </div>
                <div className="grid grid-cols-4 gap-y-4 max-lg:grid-cols-2 max-md:grid-cols-2 max-sm:grid-cols-1 gap-x-10 w-full place-items-center max-w-[80%]">
  {cards}
</div>
                <div className="grid grid-cols-2 gap-y-4 gap-x-2  max-lg:gap-x-10 max-sm:grid-cols-1 w-full  place-items-center  max-w-[70%]"  >
                {cards2}
                </div>
            </div>
        </div>
    )
}

function Card(props) {
  return (
    <div className="max-w-[18rem] speaker relative group overflow-hidden min-w-[18rem] rounded-2xl">
      {/* Speaker Image */}
      <div
        className="bg-cover bg-center rounded-2xl h-[20rem] w-full mx-auto cursor-pointer transition-transform duration-500"
        style={{ backgroundImage: `url(${props.image})` }}
      ></div>

      {/* Default card content */}
      <div className="absolute bottom-0 left-0 w-full px-4 py-2 bg-white bg-opacity-80 rounded-b-2xl hover:hidden">
        <h3 className="text-lg font-semibold text-black">{props.name}</h3>
        <p className="text-sm text-gray-600">{props.title}</p>
      </div>

      {/* Black hover overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-70 flex flex-col justify-center items-center text-white rounded-2xl p-4 opacity-0 group-hover:opacity-100 transform translate-y-full group-hover:translate-y-0 transition-all duration-500 ease-in-out">
        {/* Top-right corner link */}
        {props.link &&
        <a
        href={props.link || "#"}
        target="_blank"
        rel="noopener noreferrer"
        className="absolute top-2 right-3 text-yellow-500 text-2xl font-extrabold  underline"
      >
        <CiLink />
      </a> }

        <p className="mt-4 text-md font-bold mb-2 text-center">{props.name}</p>
        <p className="text-sm text-justify">{props.detail}</p>
      </div>
    </div>
  );
}


function CMCard(props) {
  return (
    <div className="min-w-[18rem] max-w-[18rem] sm:min-w-[22rem] sm:max-w-[22rem] lg:min-w-[24rem] lg:max-w-[24rem] speaker relative group overflow-hidden rounded-2xl">
      {/* Speaker Image */}
      <div
        className="bg-cover bg-center rounded-2xl h-[20rem] sm:h-[24rem] lg:h-[28rem] w-full mx-auto cursor-pointer transition-transform duration-500"       
        style={{ backgroundImage: `url(${props.image})` }}
      ></div>

      {/* Default card content */}
      <div className="absolute bottom-0 left-0 w-full px-4 py-2 bg-white bg-opacity-80 rounded-b-2xl hover:hidden">
        <h3 className="text-lg font-semibold text-black">{props.name}</h3>
        <p className="text-sm text-gray-600">{props.title}</p>
      </div>

      {/* Black hover overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-70 flex flex-col justify-center items-center text-white rounded-2xl p-4 opacity-0 group-hover:opacity-100 transform translate-y-full group-hover:translate-y-0 transition-all duration-500 ease-in-out">
        {/* Top-right corner link */}
        {props.link && (
          <a
            href={props.link || "#"}
            target="_blank"
            rel="noopener noreferrer"
            className="absolute top-2 right-3 text-yellow-500 text-2xl font-extrabold underline"
          >
            <CiLink />
          </a>
        )}

        <p className="mt-4 text-md font-bold mb-2 text-center">{props.name}</p>
        <p className="text-sm text-justify">{props.detail}</p>
      </div>
    </div>
  );
}


export default Leadership